"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonValidationSchema = void 0;
const yup_1 = require("yup");
const isValidJSON = (value) => {
    try {
        JSON.parse(value);
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.jsonValidationSchema = (0, yup_1.string)()
    .required("form.validations.valueMissing")
    .test("is-json", "form.validations.invalidJSON", isValidJSON);
//# sourceMappingURL=json.js.map